<template>
<ItpFormSelect2
  :name="path"
  v-model="item[path]"
  :options="meterTypes"
  valueField="value"
  textField="text"
  :clearable="clearable"
  :autofocus="autofocus"
  :disabled="readonly || item.isReadonly"
  :readonly="readonly || item.isReadonly"
  :required="required"
  v-if="item"
  @optionSelected="evh_7315092382398562_optionSelected($event, {})"
>
</ItpFormSelect2>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcMeterTypeSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: Object,
  })
  parameters!: object;

  @Watch('parameters')
  onParameters(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parameters")
  }

  @Prop({
    type: Boolean,
  })
  required!: boolean;

  @Watch('required')
  onRequired(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("required")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
  })
  autofocus!: boolean;

  @Watch('autofocus')
  onAutofocus(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("autofocus")
  }

  @Prop({
    type: Boolean,
  })
  clearable!: boolean;

  @Watch('clearable')
  onClearable(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("clearable")
  }

  meterTypes!: any;

  async $$load_meterTypes() {
    return this.$fn.getEnumValuesFromSchema('MeterTypes')
  }

  ux!: any;
  dataMembers = ['meterTypes', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        meterTypes: null,
        ux: null,
      },
    }
  }

  async act_7315092382398562_script_7786_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_7786, alias=undefined
    this.$emit('optionSelected', $event.data.option)
  }

  async act_7315092382398562_script_7786_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_7786, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_7786_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_script_7786: actions.ScriptAction;
    evh_7315092382398562_optionSelected_7785: actions.EventHandlerImpl;
    evh_7315092382398562_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_script_7786 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_7786_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_optionSelected_7785 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_7786,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_7315092382398562_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_optionSelected_7785],
      }
    );
    return {
      act_7315092382398562_script_7786,
      evh_7315092382398562_optionSelected_7785,
      evh_7315092382398562_optionSelected,
    }
  }
}

Vue.component("UcMeterTypeSelector", UcMeterTypeSelector);

</script>